"use client";
import {
  useSelectList
} from "../__chunks/KHUR3XXK.js";
import "../__chunks/DS36B3MQ.js";
import {
  useSelectProviderContext
} from "../__chunks/KZ2S4ZC5.js";
import "../__chunks/TW35PKTK.js";
import "../__chunks/5VQZOHHZ.js";
import "../__chunks/WENSINUV.js";
import "../__chunks/FMYQNSCK.js";
import {
  usePopover
} from "../__chunks/JS55N6L7.js";
import {
  createDialogComponent
} from "../__chunks/TT2355LN.js";
import "../__chunks/UQBPM777.js";
import "../__chunks/NSFBIL2Z.js";
import "../__chunks/ESSM74HH.js";
import "../__chunks/KB6RR6FL.js";
import "../__chunks/T3RMEPVH.js";
import "../__chunks/43UOHFGG.js";
import "../__chunks/HLTQOHKZ.js";
import "../__chunks/677M2CI3.js";
import "../__chunks/6GXEOXGT.js";
import "../__chunks/2PGBN2Y4.js";
import "../__chunks/63XF7ACK.js";
import "../__chunks/AOUGVQZ3.js";
import "../__chunks/K2ZF5NU7.js";
import "../__chunks/YJS26JVG.js";
import "../__chunks/HT3UEUDM.js";
import "../__chunks/5M6RIVE2.js";
import "../__chunks/UNZQGRPO.js";
import "../__chunks/LWDIJ7XK.js";
import "../__chunks/AOQQTIBO.js";
import "../__chunks/CZ4GFWYL.js";
import "../__chunks/BSEL4YAF.js";
import "../__chunks/AXRBYZQP.js";
import "../__chunks/54MGSIOI.js";
import "../__chunks/DU4D3UCJ.js";
import "../__chunks/RGUP62TM.js";
import "../__chunks/HGZKAGPL.js";
import "../__chunks/SWN3JYXT.js";
import "../__chunks/ILNAUGA4.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/HKOOKEDE.js";
import "../__chunks/QYS5FHDY.js";
import "../__chunks/KGK2TTFO.js";
import "../__chunks/2GXGCHW6.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/3YLGPPWQ.js";

// src/select/select-popover.tsx
var TagName = "div";
var useSelectPopover = createHook(
  function useSelectPopover2(_a) {
    var _b = _a, { store, alwaysVisible } = _b, props = __objRest(_b, ["store", "alwaysVisible"]);
    const context = useSelectProviderContext();
    store = store || context;
    props = useSelectList(__spreadValues({ store, alwaysVisible }, props));
    props = usePopover(__spreadValues({ store, alwaysVisible }, props));
    return props;
  }
);
var SelectPopover = createDialogComponent(
  forwardRef(function SelectPopover2(props) {
    const htmlProps = useSelectPopover(props);
    return createElement(TagName, htmlProps);
  }),
  useSelectProviderContext
);
export {
  SelectPopover,
  useSelectPopover
};
